import { useMemo, useRef } from 'react';
import type { Panel } from '@atlassian/preview-panels-api';
import type { IssuePreviewPanelsNavigationRef } from './JiraPreviewPanelsContext.tsx';

export const useInitialPanelNavigationRef = (): IssuePreviewPanelsNavigationRef => {
	const onNavigateAway = useRef<(toPanel: Panel) => void>();
	const onNavigateNext = useRef<() => void>();
	const onNavigatePrevious = useRef<() => void>();

	return useMemo(
		() => ({
			onNavigateAway,
			onNavigateNext,
			onNavigatePrevious,
		}),
		[],
	);
};
